<template>
    <div v-if="dataLoaded" class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-8">
                <manga_collection :horizontal="false" :mangas="mangas"></manga_collection>
            </div>
        </div>
    </div>
</template>

<script>
import manga_collection from "@/components/manga-collection"
import { HTTP } from "../common/http-common";

    export default {
        data() {
            return {
                mangas: [],
                key: "",
                dataLoaded: false
            }
        },
        components: {
            manga_collection
        },
        methods: {
            performSearch() {
                var source = this.source()
                let path = source + "_search/"
                HTTP.get(path, {
                    params: {
                        'key': this.key
                    }
                })
                .then(response => {
                    this.mangas = response.data["results"];
                    this.dataLoaded = true
                })
                .catch(e => {
                    this.console.error(e);
                });
            }
        },
        beforeRouteUpdate(to, from, next) {
            this.key = to.params.key
            this.performSearch()
            next()
        },
        created() {
            this.key = this.$route.params.key
            document.title = this.key
            this.performSearch()
        },
        metaInfo() {
            return {
                title: "Truyện Full Nover - Hay Đọc Truyện Online Hay Và Mới Nhất",
                meta: [
                    { name: 'description', content: 'Đọc truyện online, đọc truyện chữ, truyện hay, truyện full. Nover luôn tổng hợp và cập nhật các chương truyện từ nhiều nguồn khác nhau một cách nhanh nhất. Đặc biệt có app đọc truyện cho di động.'},
                    { property: 'og:title', content: "Truyện Full Nover - Đọc Truyện Online Hay Và Mới Nhất"},
                    { property: 'og:site_name', content: 'Nover - Hay Đọc Truyện'},
                    { property: 'og:type', content: 'website'},    
                    { name: 'robots', content: 'index,follow'} 
                ],
                link: [
                    { rel: 'canonical', href: `${ this.$route.fullPath }`}
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>